import cx from 'classnames';

import { ROUTES_BADGES_TYPES } from '~/router/routes';

import ParticleIcon from '~/Components/ParticleIcon/ParticleIcon';

import styles from './NavMenuLinks.module.scss';

import type { BadgeModel } from '~/router/navigation/types';

interface NavMenuLinksBadgeProps {
  badge: BadgeModel;
}

export const NavMenuLinksBadge = ({ badge }: NavMenuLinksBadgeProps) => {
  if (!badge || badge.kind === ROUTES_BADGES_TYPES.NONE) {
    return null;
  }

  if (badge.kind === ROUTES_BADGES_TYPES.COUNTER) {
    return (
      <span id={`${badge.id}-badge`} className={cx(styles.badge, styles.badgeBigNumber)}>
        {badge.value}
      </span>
    );
  }

  if (badge.kind === ROUTES_BADGES_TYPES.NEW) {
    return (
      <span id={`${badge.id}-badge`} className={styles.badgeNew}>
        {badge.label}
      </span>
    );
  }

  if (badge.kind === ROUTES_BADGES_TYPES.REWARD) {
    return (
      <span className={styles.badgeTasksIcon}>
        <ParticleIcon />
      </span>
    );
  }

  return null;
};
